import React, { useContext, useEffect } from 'react';

import { useTheme } from '@mui/material/styles';
import { Snackbar as MuiSnackbar, Alert } from '@mui/material';

import { SnackbarContext } from '../../contexts';
import { AuthenticationService } from '../../services';

const Snackbar = () => {
  const theme = useTheme();
  const { snackbar, snackbarIsOpen, setSnackbarIsOpen } = useContext(SnackbarContext);

  useEffect(() => {
    if (snackbar?.message) setSnackbarIsOpen(true);
  }, [snackbar, setSnackbarIsOpen]);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarIsOpen(false);
  };

  return (
    <MuiSnackbar
      style={{
        top: AuthenticationService.isLoggedIn() ? theme.spacing(14) : 0,
        left: 0,
        right: 0,
      }}
      open={snackbarIsOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
      <Alert
        icon={false}
        sx={{
          backgroundColor: snackbar.severity === 'error' ? theme.palette.error[300] : theme.palette.success[300],
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
        }}
        severity={snackbar.severity}
        variant='filled'>
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
